import { DEFAULT_GET_TREATMENTS_ROUTE } from "./constants";
import generateControlTreatment from "./generateControlTreatment";
import isClientSide from "./isClientSide";
/**
 * Function for getting treatments in client-side code
 *
 * @param treatmentNames - The treatment(s) you want to retrieve from Split.
 * @param splitKey - The Split key (or Promise of Split key) to be used.
 * @param options.apiPathString - The path to your application's treatment endpoint to override default.
 * @param options.abortController - AbortController to pass in to cancel the call. Useful for cancelling Split calls during page transitions/components unmounting.
 * @param options.attributes - Additional attributes to send to Split.
 **/
const getClientSideSplitTreatments = async (treatmentNames, splitKey, { abortController, apiPathString = DEFAULT_GET_TREATMENTS_ROUTE, attributes, } = {}) => {
    try {
        if (!isClientSide()) {
            throw new Error("cannot use server-side, use getServerSideSplitTreatments instead");
        }
        const searchParams = new URLSearchParams({
            ...(attributes ? { attributes: JSON.stringify(attributes) } : {}),
            splitKey: await splitKey,
            treatmentNames: String(treatmentNames),
        });
        const response = await fetch(`${apiPathString}?${searchParams}`, {
            signal: abortController?.signal,
        });
        if (!response.ok) {
            throw new Error(`${response.status} ${response.statusText}`);
        }
        const data = await response.json();
        return data;
    }
    catch (e) {
        const errorType = typeof e;
        const errorMessage = (errorType === "object" && e.message) ||
            (errorType === "string" && e) ||
            `ERROR_${errorType}_NO_MESSAGE`;
        if (errorMessage !== "Load failed") {
            console.error(new Error(`getClientSideSplitTreatments error for test ${String(treatmentNames)} ${errorMessage}`));
        }
        return generateControlTreatment(treatmentNames);
    }
};
export default getClientSideSplitTreatments;
